import { CLASSNAMES } from "@constants";

/**
 * Handle hamburger menu
 *
 * @param container {HTMLInputElement} container element
 *
 * * Test: KomercniBanka\src\js\modules\hamburger.ts
 */
const Hamburger = (container: HTMLInputElement) => {
  const nav = document.querySelector<HTMLElement>(".js-navMob");
  const btnCancel = document.querySelector<HTMLElement>(".js-search-cancel");
  const body = document.querySelector<HTMLElement>("body");
  const overlay = document.querySelector<HTMLElement>(".js-overlay");

  const toggleMenu = () => {
    body.classList.toggle("overflow-hidden");
    nav.classList.toggle("active");
    overlay.classList.toggle("overlay");
    btnCancel?.classList.add(CLASSNAMES.HIDDEN);
  };

  container.addEventListener("click", toggleMenu);
};

export default Hamburger;
